import { AsyncPipe, NgForOf } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AyaSchoolDataByLanguage } from '../../models';
import { SharedDataStore } from '../../store';
import { AyaCountriesSchoolListComponent } from '../aya-countries-school-list/aya-countries-school-list.component';
import { AyaExtraInfoComponent } from '../aya-footer/aya-extra-info.component';
import { AyaSummaryComponent } from '../aya-header/aya-summary.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-data',
  imports: [AyaSummaryComponent, AsyncPipe, AyaCountriesSchoolListComponent, NgForOf, AyaExtraInfoComponent],
  templateUrl: './aya-data.component.html',
  styleUrls: ['./print-aya-data.component.scss'],
})
export class AyaDataComponent {
  @Input() ayaSchoolTables$: Observable<AyaSchoolDataByLanguage[] | undefined> | undefined;

  protected currentYear$: Observable<string | undefined>;

  private readonly sharedDataStore = inject(SharedDataStore);

  constructor() {
    this.currentYear$ = this.sharedDataStore.currentPriceListYear$;
  }
}
